module.exports = __webpack_public_path__ + "img/about_premium_6.1ef35159.jpg";